<template >
  <v-app class="back">
    <v-container fluid class="doc">
      <v-row justify="start" class="my-4 ml-1">
        <span class="display-1 titulo font-weight-bold">E-mails</span>
      </v-row>
      <v-row>
        <v-col cols="12" sm="12" :md="formData.length == 0 ? '9':'12'">
          <v-card outlined class="borda" flat width="100%">
            <v-data-table
              no-data-text="Nenhum e-mail cadastrado"
              hide-default-footer
              disable-sort
              :headers="cabecalho"
              :items="formData"
              :items-per-page="items_per_pag"
              class="elevation-0"
              :loading="loading"
            >
              <template v-slot:item.acao="{ item }">
                <v-tooltip top color="black" v-if="!editModulo">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn icon v-bind="attrs" v-on="on" text>
                      <v-icon>mdi-information-outline</v-icon>
                    </v-btn>
                  </template>
                  <span>
                    Sem autorização para
                    <span class="orange--text">editar</span> ou
                    <span class="red--text">excluir</span>
                  </span>
                </v-tooltip>
                <v-menu offset-x v-if="editModulo">
                  <template v-slot:activator="{ on }">
                    <v-btn icon text v-on="on">
                      <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                  </template>
                  <v-list>
                    <div v-for="(iten, index) in opcoes" :key="index">
                      <v-list-item @click="menu(iten,item)">
                        <v-icon>{{ iten.icon }}</v-icon>
                        <v-list-item-title>{{ iten.nome }}</v-list-item-title>
                      </v-list-item>
                    </div>
                  </v-list>
                </v-menu>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
        <v-col sm="12" md="3">
          <v-row>
            <v-card flat width="100%" height="100%" class="mr-4 borda" v-if="editModulo">
              <v-col class="mr-8" v-if="formData.length < 1">
                <v-btn
                  @click="novaEntidade()"
                  large
                  rounded
                  block
                  class
                  style="background-color: #283480  !important;"
                >
                  <v-icon style="color: #00ffd4 !important" class="mr-1">mdi-account-multiple-plus</v-icon>
                  <span class="white--text">Novo e-mail</span>
                </v-btn>
              </v-col>
            </v-card>
          </v-row>
        </v-col>
      </v-row>
      <v-row v-if="showGmailAuthMethod">
        <v-col cols="12" sm="12" md="12">
          <v-card
            outlined
            class="borda"
            flat
            width="100%"
            style="border: 0.5px red solid !important;"
          >
            <v-card-title>Enviar e-mail via Gmail</v-card-title>
            <v-card-text>
              <span class="subtitle-1 black--text">Erro de conexão</span>
              <br />- Verifique o servidor e porta.
              <br />
              <span class="subtitle-1 black--text">Erro de autenticação</span>

              <br />- Verifique o email e senha do usuário.
              <br />- Ative o
              <a
                target="_blank"
                href="https://myaccount.google.com/lesssecureapps"
              >acesso de apps menos seguros</a> na conta do google.
              <br />- Entre em uma janela de navegação privada e acesse o link:
              <a
                target="_blank"
                href="https://accounts.google.com/b/0/DisplayUnlockCaptcha"
              >https://accounts.google.com/b/0/DisplayUnlockCaptcha</a>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog v-model="dialog_email" persistent width="700px">
      <v-form ref="form" v-model="valid" @submit.prevent="save()">
        <v-card flat class="borda">
          <v-card-title class="ma-2">
            Novo e-mail
            <v-spacer></v-spacer>
            <v-btn icon text @click="close()">
              <v-icon>mdi-close-thick</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="6" md="6" class="mb-n5">
                <span class="font-weight-bold black--text">Usuário *</span>
                <v-text-field
                  :rules="requiredRules"
                  v-model="novo_email.config_email_smtp_usuario"
                  solo
                  type="email"
                  dense
                  flat
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" class="mb-n5">
                <span class="font-weight-bold black--text">Senha *</span>
                <v-text-field
                  v-model="novo_email.config_email_smtp_senha"
                  :rules="requiredRules"
                  solo
                  :type="senha"
                  @click:append="ver_senha()"
                  :append-icon="senha_icone"
                  dense
                  flat
                  outlined
                ></v-text-field>
              </v-col>
              <!-- <v-col cols="12" sm="12" md="3" class="mb-n5 mt-5">
                <v-card-text class="mt-1 mb-1">
                  <v-checkbox
                    value="1"
                    @change="clearCampos()"
                    class="mb-n7 mt-n5"
                    label="Autenticado"
                    v-model="novo_email.config_email_smtp_auth"
                  ></v-checkbox>
                </v-card-text>
              </v-col>
              <v-col cols="12" sm="12" md="9" class="mb-n5">
                <span class="font-weight-bold black--text">Tipo de autenticação</span>
                <v-text-field
                  :disabled="novo_email.config_email_smtp_auth != 1"
                  v-model="novo_email.config_email_smtp_tipo_auth"
                  solo
                  :rules="requiredAut"
                  dense
                  flat
                  outlined
                ></v-text-field>
              </v-col>-->
              <v-col cols="12" sm="6" md="6" class="mb-n5">
                <span class="font-weight-bold black--text">Servidor *</span>
                <v-text-field
                  v-model="novo_email.config_email_smtp_servidor"
                  solo
                  dense
                  :rules="requiredRules"
                  flat
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" class="mb-n5">
                <span class="font-weight-bold black--text">Porta *</span>
                <v-text-field
                  v-model="novo_email.config_email_smtp_porta"
                  solo
                  dense
                  :rules="requiredRules"
                  type="number"
                  flat
                  outlined
                ></v-text-field>
              </v-col>
              <!-- <v-col cols="12" sm="12" md="6" class="mb-n5">
                <v-card-text class="mt-1 mb-1">
                  <v-checkbox
                    value="1"
                    class="mb-n7 mt-n5"
                    label="Auto assinado"
                    v-model="novo_email.config_email_smtp_auto_assinado"
                  ></v-checkbox>
                </v-card-text>
              </v-col>-->
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-row class="mb-4" no-gutters justify="center">
              <v-btn
                class="mr-2"
                @click="close()"
                rounded
                :disabled="loadingBtn"
                style="color: #283480 !important"
                outlined
              >Cancelar</v-btn>
              <v-btn
                class="ml-2"
                rounded
                :disabled="loadingBtn"
                :loading="loadingBtn"
                style="background-color: #283480  !important; color:#00FFD4  !important"
                @click="save()"
              >
                <v-icon>mdi-content-save</v-icon>
                <span>Salvar</span>
              </v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="dialog_edit_email" persistent width="700px">
      <v-form ref="form2" v-model="valid" @submit.prevent="edit()">
        <v-card flat class="borda">
          <v-card-title class="ma-2">
            Editar e-mail
            <v-spacer></v-spacer>
            <v-btn icon text @click="close()">
              <v-icon>mdi-close-thick</v-icon>
            </v-btn>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text>
            <v-row>
              <v-col cols="12" sm="6" md="6" class="mb-n5">
                <span class="font-weight-bold black--text">Usuário *</span>
                <v-text-field
                  :rules="requiredRules"
                  v-model="novo_email.config_email_smtp_usuario"
                  solo
                  type="email"
                  dense
                  flat
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" class="mb-n5">
                <span class="font-weight-bold black--text">Senha</span>

                <v-text-field
                  :rules="requiredRules"
                  v-model="novo_email.config_email_smtp_senha"
                  solo
                  :type="senha"
                  @click:append="ver_senha()"
                  :append-icon="senha_icone"
                  dense
                  flat
                  outlined
                ></v-text-field>
              </v-col>
              <!-- <v-col cols="12" sm="12" md="3" class="mb-n5 mt-5">
                 <v-card-text class="mt-1 mb-1">
                  <v-checkbox
                    @change="clearCampos()"
                    class="mb-n7 mt-n5"
                    label="Autenticado"
                    v-model="novo_email.config_email_smtp_auth"
                  ></v-checkbox>
                </v-card-text>
              </v-col>-->
              <!-- <v-col cols="12" sm="12" md="9" class="mb-n5">
                <span class="font-weight-bold black--text">Tipo de autenticação</span>
                <v-text-field
                  :disabled="novo_email.config_email_smtp_auth != 1"
                  v-model="novo_email.config_email_smtp_tipo_auth"
                  solo
                  dense
                  flat
                  outlined
                ></v-text-field>
              </v-col>-->
              <v-col cols="12" sm="6" md="6" class="mb-n5">
                <span class="font-weight-bold black--text">Servidor</span>
                <v-text-field
                  v-model="novo_email.config_email_smtp_servidor"
                  solo
                  dense
                  flat
                  :rules="requiredRules"
                  outlined
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="6" class="mb-n5">
                <span class="font-weight-bold black--text">Porta</span>
                <v-text-field
                  v-model="novo_email.config_email_smtp_porta"
                  solo
                  dense
                  type="number"
                  flat
                  :rules="requiredRules"
                  outlined
                ></v-text-field>
              </v-col>
              <!-- <v-col cols="12" sm="12" md="6" class="mb-n5">
                <v-card-text class="mt-1 mb-1">
                  <v-checkbox
                    class="mb-n7 mt-n5"
                    label="Auto assinado"
                    v-model="novo_email.config_email_smtp_auto_assinado"
                  ></v-checkbox>
                </v-card-text>
              </v-col>-->
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-row class="mb-4" no-gutters justify="center">
              <v-btn
                class="mr-2"
                @click="close()"
                :disabled="loadingBtn"
                rounded
                style="color: #283480 !important"
                outlined
              >Cancelar</v-btn>
              <v-btn
                class="ml-2"
                rounded
                :disabled="loadingBtn"
                :loading="loadingBtn"
                style="background-color: #283480  !important; color:#00FFD4  !important"
                @click="edit()"
              >
                <v-icon>mdi-content-save</v-icon>
                <span>Salvar</span>
              </v-btn>
            </v-row>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
    <v-dialog v-model="dialog_delete" persistent max-width="400">
      <v-card class="borda" flat>
        <v-card-title class="headline">Tem certeza que deseja deletar este e-mail?</v-card-title>
        <v-card-text>Se deletar este e-mail ele não poderá ser recuperado!!</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn outlined rounded color="#283480" @click="dialog_delete = false">Cancelar</v-btn>
          <v-btn
            style="background-color: #283480  !important; color:#00FFD4  !important"
            rounded
            @click="deleteItem(), dialog_delete = false"
          >Sim, tenho certeza</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-app>
</template>

<script>
import Api from "@/common/api.helper";
export default {
  data: () => {
    return {
      senha_icone: "mdi-18px mdi-eye",
      senha: "password",
      loading: "false",
      opcoes: [
        { nome: "⠀Editar", icon: "mdi-pencil-outline" },
        { nome: "⠀Excluir", icon: "mdi-delete-outline" }
      ],
      showGmailAuthMethod: false,
      menu1: false,
      menu2: false,
      loadingBtn: false,
      disable_locais: false,
      dialog_email: false,
      dialog_edit_email: false,
      dialog_delete: false,
      formData: [],
      novo_email: {
        config_email_smtp_usuario: "",
        config_email_smtp_senha: "",
        config_email_smtp_servidor: "",
        config_email_smtp_auth: "",
        config_email_smtp_tipo_auth: "",
        config_email_smtp_porta: "",
        config_email_smtp_auto_assinado: ""
      },
      valid: true,
      requiredRules: [v => !!v || "Campo Obrigatório."],
      items_per_pag: 10,
      cabecalho: [
        { text: "Usuário", align: "start", value: "config_email_smtp_usuario" },
        {
          text: "Servidor",
          align: "center",
          value: "config_email_smtp_servidor"
        },
        { text: "Ações", align: "end", sortable: false, value: "acao" }
      ],
      editModulo: false
    };
  },
  computed: {
    requiredAut() {
      let ret = "";
      if (this.novo_email.config_email_smtp_auth == 1) {
        // ret = [v => !!v || "Campo Obrigatório."];
        ret = [];
      } else {
        ret = [];
      }
      return ret;
    }
  },
  created() {
    this.getEmails();
    this.validaEdicaoModulo();
  },
  methods: {
    deleteItem() {
      this.loading = true;
      Api.delete(`/config-email/` + this.formData.id_config_email)
        .then(response => {
          if (response) {
            this.loading = false;
          }
          this.formData.id_config_email = "";
          this.getEmails();
          this.loading = false;
        })
        .catch(err => {
          this.loading = false;
          throw err;
        });
    },
    clearCampos() {
      this.novo_email.config_email_smtp_tipo_auth = "";
    },
    menu(opcao, item) {
      this.formData.id_config_email = item.id_config_email;
      if (opcao.nome === "⠀Excluir") {
        this.dialog_delete = true;
      } else if (opcao.nome === "⠀Editar") {
        this.novo_email = {
          config_email_smtp_usuario: item.config_email_smtp_usuario,
          config_email_smtp_senha: item.config_email_smtp_senha,
          config_email_smtp_servidor: item.config_email_smtp_servidor,
          config_email_smtp_auth: item.config_email_smtp_auth,
          config_email_smtp_tipo_auth: item.config_email_smtp_tipo_auth,
          config_email_smtp_porta: String(item.config_email_smtp_porta),
          config_email_smtp_auto_assinado: item.config_email_smtp_auto_assinado
        };
        this.dialog_edit_email = true;
      }
    },
    save() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        this.loadingBtn = true;
        Api.post("/config-email/checkMail", this.novo_email)
          .then(response => {
            this.loading = false;
            if (response.data.success) {
              this.$toast.success(response.data.success);
              Api.post("/config-email", this.novo_email)
                .then(response => {
                  this.loadingBtn = false;
                  this.loading = false;
                  if (response.data.id_config_email) {
                    this.$toast.success("Cadastrado com sucesso!");
                  }
                  this.showGmailAuthMethod = false;
                  this.getEmails();
                  this.$refs.form.resetValidation();
                  this.close();
                })
                .catch(err => {
                  this.loadingBtn = false;
                  this.loading = false;
                  this.$toast.error(err.data.errors);
                });
            } else {
              this.$toast.error(response.data.errors);
              this.dialog_email = false;
              this.dialog_edit_email = false;
              this.showGmailAuthMethod = true;
              this.loadingBtn = false;
              this.loading = false;
            }
          })
          .catch(err => {
            this.loadingBtn = false;
            this.loading = false;
            this.$toast.error(err.data.errors);
          });
      }
    },
    ver_senha() {
      if (this.senha == "password") {
        this.senha = "";
        this.senha_icone = "mdi-18px mdi-eye-off";
      } else {
        this.senha = "password";
        this.senha_icone = "mdi-18px mdi-eye";
      }
    },
    getEmails() {
      this.loading = true;
      Api.get(`/config-email`)
        .then(response => {
          if (response.data.data) {
            this.formData = response.data.data;
            this.loading = false;
          }
        })
        .catch(err => {
          this.loading = false;
          throw err;
        });
    },
    carregarMais() {
      if (this.formData.length > this.items_per_pag) {
        this.items_per_pag += 10;
      }
    },
    close() {
      if (this.$refs.form) {
        this.$refs.form.resetValidation();
      }
      if (this.$refs.form2) {
        this.$refs.form2.resetValidation();
      }
      this.dialog_email = false;
      this.dialog_edit_email = false;
      this.novo_email = {
        config_email_smtp_usuario: "",
        config_email_smtp_senha: "",
        config_email_smtp_servidor: "",
        config_email_smtp_auth: "",
        config_email_smtp_tipo_auth: "",
        config_email_smtp_porta: "",
        config_email_smtp_auto_assinado: ""
      };
    },
    edit() {
      if (this.$refs.form2.validate()) {
        this.loading = true;
        this.loadingBtn = true;
        Api.post("/config-email/checkMail", this.novo_email)
          .then(response => {
            this.loading = false;
            if (response.data.success) {
              this.$toast.success(response.data.success);
              Api.post(
                `/config-email/` + this.formData.id_config_email,
                this.novo_email
              )
                .then(response => {
                  this.loadingBtn = false;
                  this.loading = false;
                  if (response) {
                    this.$toast.success("Editado com sucesso!");
                  }
                  this.formData.id_config_email = "";
                  this.getEmails();
                  this.$refs.form.resetValidation();
                  this.close();
                })
                .catch(err => {
                  this.loadingBtn = false;
                  this.loading = false;
                  this.$toast.error(err.data.errors);
                });
            } else {
              this.$toast.error(response.data.errors);
              this.loadingBtn = false;
              this.loading = false;
            }
          })
          .catch(err => {
            this.loadingBtn = false;
            this.loading = false;
            this.$toast.error(err.data.errors);
          });
      }
    },
    novaEntidade() {
      this.dialog_email = true;
    },
    async validaEdicaoModulo() {
      this.editModulo = await Api.validaEdicaoModulo(
        this.$router.currentRoute.path
      );
    }
  }
};
</script>
<style lang="scss">
input:disabled {
  cursor: default;
  border-color: #bdbdbd;
  color: #bdbdbd;
}
</style>